import { ActionTypes } from '../../constants/ActionTypes';
import {
  IAppoinmentCalendar,
  IAppoinmentsModel,
} from '../../interfaces/Appointments';

export const onGetAppointmentCalendars = () => {
  return {
    type: ActionTypes.GET_APPOINTMENTS_CALENDARS,
  };
};

export const fetchAppointmentCalendarsSuccess = (
  appointmentCalendars: IAppoinmentCalendar[],
) => {
  return {
    type: ActionTypes.FETCH_APPOINTMENTS_CALENDARS_SUCCESS,
    payload: appointmentCalendars,
  };
};

export const onGetAppointments = (params: IAppoinmentsModel) => {
  return {
    type: ActionTypes.GET_APPOINTMENTS,
    payload: params,
  };
};

export const fetchAppointmentsSuccess = (appointments: any[]) => {
  return {
    type: ActionTypes.FETCH_APPOINTMENTS_SUCCESS,
    payload: appointments,
  };
};
